import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';


const StyledPasswordRules = styled.div`
  color: ${({ theme }) => theme.palette.grey[1]};
  ul {
    list-style-type: none;
    padding: 0;
    li {
      margin: ${({ theme }) => theme.spacing}px;
      &:before {
        content: "- ";
      }
    }
  }
`;

const PasswordRules = ({ className }) => (
  <StyledPasswordRules
    className={className ? `PasswordRules ${className}` : 'PasswordRules'}
  >
    <p>
      <strong>Please ensure that your password:</strong>
    </p>
    <ul>
      <li>is at least 8 characters</li>
      <li>contains both uppercase and lowercase letters (e.g. A-Z, a-z)</li>
      <li>has at least one number (e.g. 0-9)</li>
    </ul>
  </StyledPasswordRules>
);

PasswordRules.displayName = 'PasswordRules';

PasswordRules.propTypes = {
  className: PropTypes.string,
};

PasswordRules.defaultProps = {
  className: null,
};

export default PasswordRules;
